import Body from "../components/layout/Body";
import FileList from "../components/FileList";
import PatientListingSidebar from "../components/layout/Sidebar/PatientListingSidebar";

const Dashboard = () => {
    return <>
        <Body mainElement={<FileList title="Tutti i Pazienti/File Trascritti" />} sideBar={<PatientListingSidebar />} />
    </>;
}

export default Dashboard;
